
import _ from 'lodash'
import '../../../css/svdreact.css'
import Terrain from '../../terrain/Terrain'
import CardTerrain from '../../terrain/CardTerrain'

import GlassTerrain from '../../terrain/GlassTerrain'
import CliDetailContainer from './cliDetail'
import TerrainAmenitiesTablet from '../../terrain/TerraainAmenitiesTablet'
import TerrainAmenities from '../../terrain/TerrainAmenities'
import TerrainHighlights from '../../terrain/TerrainHighlights'
/*
import TerrainLocation from '../../terrain/TerrainLocation'
import TerrainGallery from '../../terrain/TerrainGallery'

import TerrainReview from '../../terrain/TerrainReview'
import TerrainStars from '../../terrain/TerrainStars'

import SJCarousel from "../../../views/SJCarousel";
import SJCarouselDyna from "../../../views/SJCarouselDyna";
*/


import { Icon, Avatar } from 'antd'
import ErrorCom from '../../core/AbodeErrorTag'
import SVAbodeSpinner from '../../core/SVAbodeSpinner';
import moment from 'moment'


import { SV_SOJ_ORCMOCK_ADDRESS, SV_SOJ_NOTCAROUSEL_VIEW } from '../../../constants'
/*
import InvBoardTable from './invBoardTable'
import InvDetAmenity from './InvDetAmenity'
import InvDetPoi from './InvDetPoi'
import InvDetAbout from './InvDetAbout'

import InvDetBus from './InvDetBus'
import InvDetEnt from './InvDetEnt' 
//import InvDetMeal from './InvDetMeal'
import InvDetSport from './InvDetSport' 
import InvDetHealth from './InvDetHealth'
import InvDetFacility from './InvDetFacility'
import InvDetMeal from './InvDetMeal'
*/
import history from "../../../history"

import { sjpriceAndTexNow } from '../../../redux/svractions/shreviewActions'


const React = require('react')

const { connect } = require("react-redux")
const { Link } = require("react-router")
const HBD_URL = 'http://photos.hotelbeds.com/giata/'


class CliTerrainContainer extends React.Component {

    constructor(props) {
        super(props)
        let me = this


        //getInvpoiContainer
    }

    //jul13 end

    getAppDetails(paramQSpaceId) {
        console.log('id detail spacekey**noCookie missing price Reatekey************', paramQSpaceId)
        //this.props.sojDetailsAndImagesSV(paramQ) 
        let paramOb = {
            paramQSpaceId: paramQSpaceId
        }
        console.log('id detail spacekey and rates using sjcook****jul14**********', paramOb)
        

        /*
    { my_esqueryText: "San Diego", STARTDATE: "2025-08-14", ENDDATE: "2025-08-15", time_zone: "+01:00" }
        */
    let ids = paramQSpaceId ? paramQSpaceId :"xxx"
    let sv_esquery_data = {
        "docId":["5"],
        "hsetname": ids
        }

    let sojPostRq ={
            "docId":[],
            "hsetname": paramQSpaceId ? paramQSpaceId :"xxx"
            }
    sojPostRq.docId.push(ids)
    this.props.cliAndImagesCruisePaginate1HotelById(sojPostRq, sv_esquery_data);


    }
    getAppDetailsUseCookie(paramQSpaceObWithId) {
        let paramQSpaceId = paramQSpaceObWithId.id

        let paramOb = {
            paramQSpaceId: paramQSpaceId
        }
        console.log('id detail spacekey and rates using sjcook****jul14**********', paramOb)
        

        /*
    { my_esqueryText: "San Diego", STARTDATE: "2025-08-14", ENDDATE: "2025-08-15", time_zone: "+01:00" }
        */
       let ids = paramQSpaceId ? paramQSpaceId :"xxx"
        let sv_esquery_data = {
            "docId":["5"],
            "hsetname": ids
            }

        let sojPostRq ={
                "docId":[],
                "hsetname": paramQSpaceId ? paramQSpaceId :"xxx"
                }
        sojPostRq.docId.push(ids)
        this.props.cliAndImagesCruisePaginate1HotelById(sojPostRq, sv_esquery_data);


    }
    componentWillMount() {
        console.log('sv--task=--- link sends us params')
        console.log(this.props.params)
        //console.log(this.props.params.id)
        let id;
        if (this.props.svparams) {
            id = this.props.svparams

        } else {
            console.log('not called by router')
            id = 1;
        }

        console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:' + id)


        /*   this.state = {
             tasks: svtasks[0]
           }
       */

        // this.getAppDetails(id)
        this.getAppDetailsUseCookie(id)




    }

    getMyHtml() {
        let ar = this.state.my_data;

        console.log(this.state)
        console.log(ar);
        const my_data = this.state.my_data;
        return my_data.map(o => {
            console.log(o)
            return (<li>{o.name}</li>)
        });
    }

    /*
        getChildContainersOld() {
            const legend = [{
                "sojourncode": "100",
                "vernacularcode": "EN",
                "sojourn_name": "253 Mancreek Resort"
            },
            {
                "sojourncode": "101",
                "vernacularcode": "EN",
                "sojourn_name": "253 John Resort"
            }]
            let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
            if (this.props.data && (this.props.data.length > 0)) {
                data = this.props.data
            }
           
            if (this.props.my_data && (this.props.my_data.length > 0)) {
                my_data = this.props.my_data
            }
           
            return (
                <div>
    
      <a target="_blank" rel="noopener noreferrer" href="https://www.booking.com/hotel/us/san-diego-del-mar.html?label=gen173nr-1FCAEoggI46AdIM1gEaIkCiAEBmAExuAEYyAEP2AEB6AEB-AECiAIBqAIEuAKNu_CxBsACAdICJGY4NTJhN2NkLTkxMmItNDE1Zi04ZGI4LTVjYWRjNDU2N2M3NNgCBeACAQ&amp;aid=304142&amp;ucfs=1&amp;arphpl=1&amp;checkin=2024-05-24&amp;checkout=2024-06-07&amp;dest_id=20015725&amp;dest_type=city&amp;group_adults=2&amp;req_adults=2&amp;no_rooms=1&amp;group_children=0&amp;req_children=0&amp;hpos=1&amp;hapos=1&amp;sr_order=popularity&amp;srpvid=025e05dca08401b2&amp;srepoch=1715217706&amp;all_sr_blocks=26285401_246425381_0_42_0&amp;highlighted_blocks=26285401_246425381_0_42_0&amp;matching_block_id=26285401_246425381_0_42_0&amp;sr_pri_blocks=26285401_246425381_0_42_0__250600&amp;from_sustainable_property_sr=1&amp;from=searchresults&amp;map=1" class="a83ed08757 f88a5204c2 a1ae279108 b98133fb50"><span><span class="aee5343fdb def9bc142a" data-testid="address">Carmel Valley, San Diego</span><span class="aee5343fdb def9bc142a">Show on map</span></span></a><span class="aee5343fdb"><span class="f419a93f12"><span aria-expanded="false" data-testid="distance">16.1 miles from downtown</span></span></span><span class="aee5343fdb"><span class="f419a93f12"><span aria-expanded="false">Beach Nearby</span></span></span>
      
                    {
    
                         my_data.map(o => {
                            console.log(o)
                            return (<li>{_.join(o.amenity_name) }</li>)
                        })
                    }
                </div>
               
                
                )
        }
    */

    getChildContainers() {
        /*   <TerrainLocation  svrlocation={svr_location}></TerrainLocation> */
        let cruise = null, data = [], hosts = [], dbs = [], sojourns = [], my_data = [], fgtree = []

        
        console.log('SJUL14***** this.props')
        console.log(this.props)
        console.log('SJUL14***** this.props END')
        //let svr_tablets = ["http://localhost:8080/images/soj2.jpg", "http://localhost:8080/images/soj3.jpg", "http://localhost:8080/images/soj4.jpg", "http://localhost:8080/images/soj5.jpg", "http://localhost:8080/images/soj6.jpg" ]
        if (this.props.cruiseDetailView.my_data && (this.props.cruiseDetailView.my_data.length > 0)) {
            my_data = this.props.cruiseDetailView.my_data
            cruise = my_data[0]
        }
        
        let plot = 'RESULT'
        const lastestUpdateDate = 'Data Refresh Daily'
        return (<div >
            <header className="svr-header1">
                <h1> Cruise  Itinerary, {cruise.shipCode} - {cruise.itineraryTitle}</h1>
            </header>
           
        <CliDetailContainer svexcursion={cruise} ></CliDetailContainer>
        




            {/* 
            <footer>
                <p>Copyright 2013, SV Greek Text Generator, Inc.</p>
                <p>Contact <a href="mailto:nobody@nowhere.com"> w-mail@xx.com</a> </p>
            </footer>
             */}
        </div>

        )

    }




    getHotelDetailBodyContainer_soj(my_data) {
        const lastestUpdateDate = 'Data Refresh Daily'
        if (this.props.error && (this.props.error === true)) {
            console.log('sv**container ger errob')
            let errob = {
                "timestamp": "2015-08-23T02:27:18.038+0000",
                "status": 500,
                "error": "FlyServer Error",
                "message": "No Resulst Found.Please refinse search and try again",
                "path": "/kk/svaddressDetailPost"
            }
            let today_dt = new Date()
            errob["timestamp"] = today_dt
            return (
                <div >

                    <div style={{ paddingTop: '10px' }}>
                        <ErrorCom closecbParent={this.closecbParent} errob={errob} ></ErrorCom>
                    </div>


                </div>
            )

        } else if (this.props.loading && (this.props.loading === true)) {
            return (

                <div >
                    <h3>Spinner*****</h3>
                    <div style={{ paddingTop: '10px' }}>


                        <SVAbodeSpinner />
                    </div>


                </div>


            )

        }
        /*
          if (this.props.loading) {
    return <Loader type='spinner' />
    } else if (this.props.error) {
    return <ErrorWidget error={this.props.error} />
    }
    */
   
        return (
            <noop>

            

            { this.getChildContainers()}

            {/* 
             <GlassTerrain lastestUpdateDate={lastestUpdateDate} body={this.getChildContainers()}></GlassTerrain>

            */}
            </noop>
           
        )
    }

/*
    getCarouselOrPhoto = (o) => {
        let ar = o['imgs']
        let roomImgs = ar
        let roomImg = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`
        if (roomImgs && (roomImgs.length > 0)) {
            roomImg = roomImgs[0]
        }

        let photoOnly = SV_SOJ_NOTCAROUSEL_VIEW ? SV_SOJ_NOTCAROUSEL_VIEW : false

        if (photoOnly) {
            return (
                <div className="gallery">
                    <figure style={{ 'marginBottom': '0px' }}>
                        <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}>

                            <img src={`${roomImg}`} alt="Carpet Grass" />
                        </Link> </span>

                    </figure>
                </div>)

        }
        //check ar
        if (ar && (ar.length > 2)) {
            let roomImgs = ar.slice(0, 6)
            return (<SJCarouselDyna roomImgs={roomImgs} ></SJCarouselDyna>)

        } else {
            return (<SJCarousel ></SJCarousel>)
        }

    }
    */
    render() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title } = this

        /*to do we donot neeed care - terrain is card . just planin textstyel images page to hsow terrrain  */

        console.log('svrender', this.props)
        const { my_data } = this.props

        return (


            <div className="col-md-12">
                {/* 
                <h1>We call CliDetail with my_data</h1>
                */}
                {
                    this.getHotelDetailBodyContainer_soj(my_data)
                }


            </div>
        )

    }

}

export default CliTerrainContainer